var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.28 23.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.133,11.475C.141,5.191,5.174,.183,11.469,.193c6.284,.01,11.261,5.053,11.32,11.324,.056,5.954-5.195,11.589-11.957,11.285C5.105,22.545,.125,17.503,.133,11.475Zm3.121,.1c-.205,3.841,3.291,8.143,8.169,8.154,4.475,.01,8.273-3.767,8.299-8.232,.026-4.406-3.847-8.231-8.315-8.21-4.539,.021-8.156,3.698-8.154,8.288Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.454,10.478c0-.969,.003-1.715-.001-2.461-.004-.657,.296-1.077,.964-1.099,.686-.022,.998,.459,1.041,1.059,.055,.778,.013,1.563,.013,2.497,.8,0,1.46,.017,2.119-.004,.744-.024,1.458,.146,1.466,.99,.009,.905-.73,1.098-1.518,1.078-.624-.016-1.25-.003-2.04-.003,0,.799,.002,1.494,0,2.189-.003,.751-.225,1.389-1.104,1.364-.831-.024-.97-.65-.948-1.352,.021-.665,.004-1.332,.004-2.201-.843,0-1.576-.014-2.307,.004-.738,.018-1.306-.264-1.304-1.035,.002-.773,.577-1.047,1.311-1.029,.702,.018,1.404,.004,2.303,.004Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.4f61c39d0d82fbf816b5320ceb1bbc3b.svg";
export { ForwardRef as ReactComponent };